// extracted by mini-css-extract-plugin
export default {"sideServiceApp":"SideServicesApp_sideServiceApp__Khccq","verticalText":"SideServicesApp_verticalText__CtcfH","chatIcon":"SideServicesApp_chatIcon__3vHPN"};